//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import card from '@/components/card/card.vue';
import pluginCard from '~/components/card/plugin-card.vue';
import avatar from '@/components/avatar.vue';
import { needXssKeys } from '@/utils/constants';
import { replaceToOriginStr, kFormatter } from '~/utils/tools';
import emptyUser from '@/components/empty-user.vue';
import { pluginApiUrlMap } from '~/api/url';

export default {
  components: {
    card,
    avatar,
    emptyUser,
    pluginCard,
  },
  data() {
    return {
      privateResources: [],
      publicResources: [],
      pluginData: [],
      saveList: [], // 收藏列表
      resourceUserInfo: {},
      pluginInfo: {},
      loading: false,
      activeTab: this.$route.query.tab || 'resource',
      saveType: 'resource',
      userId: this.$route.params.id,
      tabCount: {
        resource: 0,
        plugin: 0,
        save: 0,
      },
      showAll: false, // 展示资源和插件tab
      getShowAll: true,
      isLoadMore: false,
      canLoadMore: true,
      pageSize: 24,
    };
  },
  computed: {
    userInfo() {
      return this.$store?.state?.user?.userInfo || {};
    },
    isSelf() {
      const user_id = +this.userId;
      return this.userInfo?.id && this.userInfo.id === user_id;
    },
    isEmpty() {
      // 当是自己的时候作品区域为空
      return !this.publicResources.length && !this.privateResources.length;
    },
    authorInfo() {
      const id = this.resourceUserInfo.author_id;
      return id ? this.resourceUserInfo : this.pluginInfo;
    },
    isResourceSave() {
      return this.saveType === 'resource';
    },
    userDataList() {
      return [
        {
          visible: this.activeTab !== 'save',
          icon: 'heart-border',
          count: this.parseData(
            this.activeTab === 'resource' ? this.resourceUserInfo.res_like_cnt : this.resourceUserInfo.plugin_like_cnt,
          ),
          text: '收藏',
        },
        {
          visible: this.activeTab === 'resource',
          count: this.parseData(this.resourceUserInfo.all_copy_cnt),
          icon: 'copy',
          text: '副本',
        },
        {
          visible: this.activeTab === 'plugin',
          count: this.parseData(this.resourceUserInfo.install_cnt),
          icon: 'down-load',
          text: '',
        },
      ].filter((item) => item.visible && item.count);
    },
  },
  watch: {
    userInfo(cur, old) {
      if (cur.id === old.id) return;
      this.getProfile();
    },
  },
  created() {
    this.initUser();
    this.initData();
  },
  mounted() {
    this.$sensors.track('page_view', {
      action_position: 'profile',
    });
    window.addEventListener('scroll', this.scrollEvent);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.scrollEvent);
  },
  asyncData({ app }) {
    app.head.title = '个人主页-MasterGo 社区';
  },
  methods: {
    scrollEvent() {
      if (this.ticking) return;
      window.requestAnimationFrame(() => {
        const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        const clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
        const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
        const scrollTotal = scrollTop + clientHeight;
        const offsetBottom = 50;
        if (scrollTotal + offsetBottom >= scrollHeight) {
          this.loadMore();
        }
        this.ticking = false;
      });
      this.ticking = true;
    },
    allSwitch(...callFnList) {
      let fn;
      switch (this.activeTab) {
        case 'resource': {
          fn = callFnList[0];
          break;
        }
        case 'plugin': {
          fn = callFnList[1];
          break;
        }
        case 'save': {
          fn = callFnList[2];
          break;
        }
        default: {
          break;
        }
      }
      if (typeof fn === 'function') {
        return fn.call(this);
      }
      return fn;
    },
    async loadMoreSave() {
      if (!this.saveList.length) return;
      this.isLoadMore = true;
      const last = this.saveList[this.saveList.length - 1];
      this.saveListParams.last_time = last.like_time;
      delete this.saveListParams.page_num;
      const { activeTab } = this;
      const { res_type } = this.saveListParams;
      try {
        const dataList = await this.getSaveData();
        if (activeTab !== this.activeTab || this.saveListParams.res_type !== res_type) return;
        this.saveList = this.saveList.concat(dataList);
      } catch {
        //
      } finally {
        if (activeTab !== this.activeTab || this.saveListParams.res_type === res_type) {
          this.isLoadMore = false;
        }
      }
    },
    async loadMoreResource() {
      if (!this.publicResources.length) return;
      this.isLoadMore = true;
      const last = this.publicResources[this.publicResources.length - 1];
      this.resourceParams.last_time = last.submit_time;
      delete this.resourceParams.page_num;
      const { activeTab } = this;
      try {
        const dataList = await this.getResourceData();
        if (activeTab !== this.activeTab) return;
        this.publicResources = this.publicResources.concat(dataList);
      } catch {
        //
      } finally {
        if (activeTab === this.activeTab) {
          this.isLoadMore = false;
        }
      }
    },
    async loadMorePlugin() {
      if (!this.pluginData.length) return;
      this.isLoadMore = true;
      const last = this.pluginData[this.pluginData.length - 1];
      this.pluginParams.last_plugin_id = last.plugin_id;
      delete this.pluginParams.page_num;
      const { activeTab } = this;
      try {
        const dataList = await this.getPluginData();
        if (activeTab !== this.activeTab) return;
        this.pluginData = this.pluginData.concat(dataList);
      } catch {
        //
      } finally {
        if (activeTab === this.activeTab) {
          this.isLoadMore = false;
        }
      }
    },
    loadMore() {
      if (!this.canLoadMore || this.isLoadMore) return;
      this.allSwitch(this.loadMoreResource, this.loadMorePlugin, this.loadMoreSave);
    },
    getResourceData() {
      return this.$axios.$post('/community/api/get-user-release-list', this.resourceParams).then((res) => {
        this.canLoadMore = res.data && res.data.length === this.pageSize;
        return res?.data || [];
      });
    },
    getPluginData() {
      return this.$axios.$get(pluginApiUrlMap.getUserReleasedPlugins, { params: this.pluginParams }).then((res) => {
        this.canLoadMore = res.data && res.data.length === this.pageSize;
        return res?.data || [];
      });
    },
    getSaveData() {
      return this.$axios.$get('/community/api/liked-resource', { params: this.saveListParams }).then((res) => {
        this.canLoadMore = res.data && res.data.length === this.pageSize;
        const list = res?.data || [];
        if (this.isResourceSave) {
          return list.map((element) => ({
            ...element,
            res_name: element.name,
            plugin_logo: '',
            plugin_desc: element.desc,
            like_cnt: element.like_cnt,
            install_cnt: element.copy_cnt,
            loading: false,
          }));
        }
        return list.map((element) => ({
          ...element,
          plugin_id: element.res_id,
          plugin_name: element.name,
          plugin_framerate_url: element.plugin_framerate_url || element.cover_url,
          plugin_desc: element.desc,
          loading: false,
        }));
      });
    },
    parseData(num) {
      if (!num) return 0;
      return kFormatter(num);
    },
    changeSaveType(type) {
      if (this.saveType === type) return;
      this.saveType = type;
      this.saveList = [];
      this.initSaveData();
      this.updateUser();
    },
    initPluginData() {
      this.loading = true;
      const user_id = +this.userId;
      this.pluginParams = {
        page_size: this.pageSize,
        page_num: 1,
        author_id: user_id,
      };
      this.getPluginData()
        .then((data) => {
          data.forEach((element) => {
            element.loading = false;
          });
          this.pluginData = data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    async initResourceData() {
      try {
        this.loading = true;
        const user_id = +this.$route.params.id;
        this.resourceParams = {
          user_id,
          page_size: this.pageSize,
          page_num: 1,
        };
        const promiseList = [];
        const p1 = this.getResourceData();

        promiseList.push(p1);
        if (this.isSelf) {
          const p2 = this.$axios.$post('/community/api/on-release');
          promiseList.push(p2);
        }
        const [res1, res2] = await Promise.all(promiseList);
        this.loading = false;
        this.publicResources = res1;
        if (res2) {
          let { in_audit, failed_audit, under_audit } = res2.data;
          in_audit = in_audit || [];
          failed_audit = failed_audit || [];
          under_audit = under_audit || [];
          in_audit.forEach((resource) => {
            resource.status = '1';
          });
          failed_audit.forEach((resource) => {
            resource.status = '2';
          });
          under_audit.forEach((resource) => {
            resource.status = '3';
          });
          const privateResources = [...in_audit, ...failed_audit, ...under_audit];
          this.privateResources = privateResources;
        }
      } catch {
        this.loading = false;
      }
    },
    async initSaveData() {
      this.loading = true;
      this.canLoadMore = true;
      this.isLoadMore = false;
      const { isResourceSave } = this;
      this.saveListParams = {
        page_size: this.pageSize,
        page_num: 1,
        res_type: isResourceSave ? 0 : 1,
        user_id: +this.userId,
      };
      try {
        const list = await this.getSaveData();
        if (isResourceSave !== this.isResourceSave) return;
        this.saveList = list;
      } catch {
        //
      } finally {
        this.loading = false;
      }
    },
    initData() {
      if (process.client) {
        this.allSwitch(this.initResourceData, this.initPluginData, this.initSaveData);
      }
    },
    initUser() {
      const userParams = {};
      const { id } = this.$route.params;
      const user_id = +id;

      if (user_id) {
        userParams.user_id = user_id;
      }
      this.$axios
        .$get(pluginApiUrlMap.getUserPluginInfo, {
          params: {
            author_id: user_id,
          },
        })
        .then((res) => {
          this.pluginInfo = res.data[0];
        });
      if (process.client) {
        this.getProfile().then(() => {
          if (!this.showAll && this.isSelf) this.changeTab('save');
        });
      }
      this.updateUser();
    },
    getUserCount() {
      const user_id = +this.$route.params.id;
      this.$axios.$post('/community/api/user', { user_id }).then((res) => {
        const resUserInfo = res.data;
        if (resUserInfo) {
          const keys = Object.keys(resUserInfo).filter((key) => needXssKeys.includes(key));
          keys.forEach((key) => {
            if (typeof resUserInfo[key] === 'string') resUserInfo[key] = replaceToOriginStr(resUserInfo[key]);
          });
        }
        this.resourceUserInfo = resUserInfo || {};
      });
    },
    getProfile() {
      if (!this.userInfo.id) {
        this.getShowAll = false;
        return Promise.resolve();
      }
      const fname = 'web.resourcePublish';
      return this.$axios
        .$post('/api/v1/experiment/swh/user', { fname })
        .then((res) => {
          this.showAll = res.data[fname];
          this.getShowAll = false;
        })
        .catch(() => {
          this.getShowAll = false;
        });
    },
    getTabCount() {
      return this.$axios
        .$get('/community/api/user-resource-count', { params: { user_id: +this.$route.params.id } })
        .then((res) => {
          const { resource_count, plugin_count, liked_count } = res.data;
          this.tabCount = {
            resource: resource_count,
            plugin: plugin_count,
            save: liked_count,
          };
          return res;
        });
    },
    updateUser() {
      this.getTabCount();
      this.getUserCount();
    },
    goHome() {
      this.$router.push('/');
    },
    goPluginHome() {
      this.$router.push('/plugin');
    },
    changeTab(type) {
      if (type === this.activeTab) return;
      this.activeTab = type;
      this.clearData();
      const query = this.$route.query; // 这里可以用Vue的方法获取参数，也可以用正则的方法获取url中的参数
      const new_query = { ...query, tab: this.activeTab };
      this.$router.replace({ query: new_query });
      this.initData();
      this.updateUser();
      this.setProfileViewSensors(type);
    },
    clearData() {
      this.loading = false;
      this.pluginData = [];
      this.publicResources = [];
      this.privateResources = [];
      this.saveList = [];
      this.ticking = false;
      this.canLoadMore = false;
      this.isLoadMore = false;
    },
    setProfileViewSensors(type) {
      const activeType = type === 'save' ? 'favorite' : type;
      this.$sensors.track('event_click', {
        action_position: 'community_profile',
        action_parameter0: 'tab',
        action_type: activeType,
      });
    },
  },
};
